import axios from '@/axiosInterceptor';

const state = () => ({
  ownershipData: null,
  ownershipDetails: null,
});

const actions = {
  async createOwnershipCompany({ commit }, { companyId }) {
    const body = {
      ownership: {
        company_id: companyId,
      },
    };
    try {
      let res = await axios.post(
        `${process.env.API_MONITOR}/api/v1/ownerships`,
        body
      );
      commit('setOwnership', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getOwnershipByCompanyId({ commit }, companyId) {
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/ownerships/by_company/${companyId}`
      );
      commit('setOwnership', res.data);
      return res;
    } catch (e) {
      const status = e.response?.status;

      if (axios.isAxiosError(e) && status) {
        if ([401, 403, 422].includes(status)) {
          throw e;
        }
        if (status === 404) {
          return null;
        }
      }

      throw e;
    }
  },
  async getOwnershipUsers(_, companyId) {
    try {
      let res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/ownerships/${companyId}/users`
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getOwnershipByUserId({ commit }, userId) {
    try {
      let res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/ownerships/by_user_id/${userId}`
      );
      commit('setOwnershipDetails', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async createOwnershipUser(
    _,
    { ownershipId, email, type, jobTitle, percentage, details_confirmed_at }
  ) {
    const body = {
      ownership_user: {
        ownership_id: ownershipId,
        invited_user_email: email,
        job_title: jobTitle,
        ownership_percentage: percentage,
        is_type: type,
        details_confirmed_at,
      },
    };
    try {
      let res = await axios.post(
        `${process.env.API_MONITOR}/api/v1/ownership_users`,
        body
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        throw e;
      } else {
        throw e;
      }
    }
  },
  async UpdateOwnershipUser(_, { ownershipId, body }) {
    try {
      let res = await axios.patch(
        `${process.env.API_MONITOR}/api/v1/ownership_users/${ownershipId}`,
        body
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        throw e;
      } else {
        throw e;
      }
    }
  },
  async emailForControllingManagerAndOwners(_, connection_id) {
    try {
      const res = await axios.post(
        `${process.env.API_MONITOR}/api/v1/connections/${connection_id}/email_for_controlling_manager_and_owners`
      );
      return res;
    } catch (e) {
      if (
        axios.isAxiosError(e) &&
        [403, 422, 500].includes(e?.response?.status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  async emailForOwners(_, connection_id) {
    try {
      const res = await axios.post(
        `${process.env.API_MONITOR}/api/v1/connections/${connection_id}/email_for_owners`
      );
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async changeControllingManager(_, body) {
    try {
      const res = await axios.put(
        `${process.env.API_MONITOR}/api/v1/ownership_users/change_controlling_manager`,
        body
      );
      return res;
    } catch (e) {
      if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async recordAttestation(_, ownershipUserId) {
    const body = {
      ownership_user: {
        attested_all_beneficial_owners_at: true,
      },
    };
    try {
      let res = await axios.patch(
        `${process.env.API_MONITOR}/api/v1/ownership_users/${ownershipUserId}/record_attestation`,
        body
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        throw e;
      } else {
        throw e;
      }
    }
  },
  async recordCertification(_, ownershipUserId) {
    const body = {
      ownership_user: {
        certified_identity_and_ownership_information_is_correct_at: true,
      },
    };
    try {
      let res = await axios.patch(
        `${process.env.API_MONITOR}/api/v1/ownership_users/${ownershipUserId}/record_certification`,
        body
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        throw e;
      } else {
        throw e;
      }
    }
  },
};

const mutations = {
  setOwnership(state, ownership) {
    state.ownershipData = ownership;
  },
  setOwnershipDetails(state, ownership) {
    state.ownershipDetails = ownership;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
